/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SVGIcons } from "cms/icons/svg-icons";
import { isTrue } from "utils/empty-exists";

const CTAStyleLink = (props) => {

    const link = props?.link;
    const style = props?.style;
    const isExternal = isTrue(link?.is_external);
    const internalNewTab = link?.new_tab ?? false;
    const openInNewTab = isExternal || internalNewTab;
    const target = openInNewTab ? "_blank" : "_self";

    return (
        <a
            href={link?.url}
            className={`displayLink ${style} `}
            target={target}
            rel='noreferrer'
        >
            {link.text}
            {isExternal
                ? <SVGIcons.fields.LinkField />
                : <SVGIcons.common.RightArrow />
            }
        </a>
    );
};

export { CTAStyleLink };


// const useStyles = makeStyles((theme) => ({
//     listItem: {
//         paddingLeft: 0,
//     },
//     displayLink: {
//         margin: 0,
//         textDecoration: `none`,
//         display: `block`,
//         color: `#0E7490`,
//         fontSize: `1rem`,
//         lineHeight: 1.75,
//         '& svg': {
//             width: 16,
//             height: 16,
//             marginLeft: 6,
//             marginRight: 12,
//             '& path': {
//                 fill: `#0E7490`,
//             },
//         },
//         '&.body': {
//             fontSize: `1rem`,
//             fontWeight: 400,
//             color: `#0E7490`,
//         },
//         '&.h1': {
//             fontSize: `2.5rem`,
//             lineHeight: 1.5,
//             fontWeight: 700,
//             color: `#0E7490`,
//         },
//         '&.h2': {
//             fontSize: `1.75rem`,
//             fontWeight: 600,
//             color: `#0E7490`,
//             '& svg': {
//                 width: 20,
//                 height: 20,
//                 marginLeft: 6,
//                 marginRight: 12,
//                 '& path': {
//                     fill: `#0E7490`,
//                 },
//             },
//         },
//         '&.h3': {
//             fontSize: `1.25rem`,
//             fontWeight: 500,
//             color: `#0E7490`,
//         },
//     },
// }))
